import React from 'react';
import { INLINES } from '@contentful/rich-text-types';
import { renderRichText } from 'gatsby-source-contentful/rich-text';

import ExternalLink from '@core/ExternalLink';

const options = {
  renderNode: {
    [INLINES.HYPERLINK]: ({ content, data: { uri } }) =>
      content.map(({ value }, index) => (
        <ExternalLink href={uri} title={value} key={index}>
          {value}
        </ExternalLink>
      )),
  },
};

export default field => renderRichText(field, options);
